import i18n from '@/plugins/i18n'

export const evaluationUnits = [
    {
        // header: i18n.t('common.distance'),
        name: i18n.t('units.meters'),
        value: 'meters'
    },
    {
        // header: i18n.t('common.distance'),
        name: i18n.t('units.yards'),
        value: 'yards'
    },
    {
        // header: i18n.t('common.time'),
        name: i18n.t('units.seconds'),
        value: 'seconds',
    },
    {
        // header: i18n.t('common.time'),
        name: i18n.t('units.minutes_seconds'),
        value: 'minutes_seconds'
    },
    {
        // header: i18n.t('common.others'),
        name: i18n.t('units.newton'),
        value: 'newton'
    },
    {
        // header: i18n.t('common.others'),
        name: i18n.t('units.watts'),
        value: 'watts'
    },
    {
        // header: i18n.t('common.others'),
        name: i18n.t('units.weight_kg'),
        value: 'weight_kg'
    },
    {
        // header: i18n.t('common.others'),
        name: i18n.t('units.weight_lb'),
        value: 'weight_lb'
    },
    {
        // header: i18n.t('common.others'),
        name: i18n.t('units.angles'),
        value: 'angles'
    },
    {
        // header: i18n.t('common.others'),
        name: i18n.t('units.none'),
        value: 'none'
    },
]